export const TEST_IDS = {
    CAMPAIGN_FORM: {
        ROOT: "campaign-form--root",
        SAVE_BUTTON: "campaign-form--save-button",
    },
};
